//import Cookies from 'js-cookie';
const Cookies = require('js-cookie');
import TokenSaveType from "./tokenSaveType";

enum EnumErrorCodes {
  SessionEnded = 5
}

export class WebApiService {
  websocket: WebSocket;
  subscribers = new Array<SocketSubscribersModel>();
  sendOrder = new Array<string>();
  url: string
  public cookieName = "Auth-Token";
  tokenSaveType: TokenSaveType = TokenSaveType.Cookies
  /**
   *включить реконнекты при потере соединения
   *
   * @type {boolean}
   * @memberof WebApiService
   */
  reconnectEnabled: boolean = true
  /**
   *Время простоя перед реконнектом после потери соединения
   *
   * @type {number}
   * @memberof WebApiService
   */
  reconnectTimeout: number = 10 * 1000;
  /**
   *флаг обозначающий наличие подключения к вебсокету
   *
   * @type {boolean}
   * @memberof WebApiService
   */
  connected: boolean = false;
  /**
   * 
   * @param url url для подключения к вебсокету. должен начинаться с ws:// или с wss://
   */
  constructor(private baseUrl: string, cookieName:string = "Auth-Token") {
    this.cookieName = cookieName;
  }
  public init(){
    this.initUrl();
    this.connect(); 
  }
  private initUrl() {
    this.url = this.addTokenToUrl(this.baseUrl);
  }
  /**
   * Подключиться к вебсокету
   */
  private connect(){    
    this.dispose();
    this.websocket = new WebSocket(this.url);
    this.websocket.onmessage = this.onMessage.bind(this);
    this.websocket.onopen = this.onOpen.bind(this);
    this.websocket.onerror = this.onError.bind(this);    
    this.websocket.onclose = this.onClose.bind(this);
    this.connected = true;
  }
  private clearReconnect() {
    // удалить токен
    this.clearToken();
    // пересоздать урл с новым токеном
    this.initUrl();
    // переподключить
    this.connect();    
  }
  /**
   * уничтожить объект вебсокет
   */
  private dispose(){    
    if(!this.websocket)
      return;    
    this.websocket.onmessage = null;
    this.websocket.onopen = null;
    this.websocket.onerror = null;    
    this.websocket.onclose = null;
    this.websocket = null;
  }
  /**
   * Удаляем токен из куки
   */
  private clearToken() {
    if(this.tokenSaveType == TokenSaveType.Cookies) {
      Cookies.remove(this.cookieName);
    } else {
      localStorage.removeItem(this.cookieName)
    }
  }
  private newGuid(): string{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });    
  }

  private getCookieToken():string {
    var token = Cookies.get(this.cookieName);
    if(!token)
      token = this.newGuid(); 
    // 30 days
    Cookies.set(this.cookieName,token, {expires: new Date(new Date().getTime() + 30*24*60*60 * 1000)});
    return token;    
  }

  private getLocalStorageToken():string {
    var token = localStorage.getItem(this.cookieName);
    if(!token)
      token = this.newGuid();
    localStorage.setItem(this.cookieName, token);
    return token;
  }

  private getToken():string{
    var token = "";
    switch(this.tokenSaveType) {
      case TokenSaveType.Cookies:
        token = this.getCookieToken();
        break;
      case TokenSaveType.LocalStore:
        token = this.getLocalStorageToken();
        break;
    }
    return token;
  }
  private addTokenToUrl(url: string):string{
    var token = this.getToken();
    if(url.indexOf('?')>=0)
      return url + '&token='+token;
    return url + '?token='+token;
  }
  onMessage(msg: MessageEvent) {
    const json = JSON.parse(msg.data);
    var controller = json.Class;
    var method = json.Method;
    var data = json.Value;
    // if(!json.IsSuccess)
    //   console.error('error response: ',json)
    var callers = this.subscribers.filter(x=> {
      return x.controller == controller && x.method == method;
    });
    callers.forEach(c=>c.callback(json));
    var errorCode = (json || {}).ErrorCode || 0;
    if (errorCode == EnumErrorCodes.SessionEnded) {
      this.clearReconnect();
    }
  }
  onError(e:Event) {
    console.error('Websocket unexpected ERROR',e);
    this.connected = false;
  }
  onClose(e:CloseEvent) {    
    console.error('Websocket CLOSED', e);
    this.connected = false;
    var self = this;
    if(this.reconnectEnabled)
      setTimeout(function(){
        self.connect();
      },self.reconnectTimeout)
  }
  onOpen() {
    if (this.sendOrder) {
      this.sendOrder.forEach(so => this.websocket.send(so))
    }
    this.sendOrder = new Array<string>();
  }
  on(controller: string, method: string, callback: Function) {
    this.subscribers.push({
      controller: controller,
      method: method,
      callback: callback
    });
  }
  send(controller: string, method: string, data?: any) {
    var value = data;
    if (typeof data !== 'string')
      value = JSON.stringify(data===undefined|| data===null?'': data)

    var sendData = JSON.stringify({
      controller: controller,
      method: method,
      value: value
    });    
    if (this.websocket.readyState != 1) { // open
      this.sendOrder.push(sendData);
      return;
    }
    this.websocket.send(sendData)
  }
}
interface SocketSubscribersModel {
  controller: string;
  method: string;
  callback: Function;
}